/**************************************************
 * Nombre:       Formulario_Cuentas_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined} from "@mui/icons-material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Cuentas_Documentos_Requeridos from "./Formulario_Cuentas_Documentos_Requeridos";
import Tarjeta_Cuentas_Documento_Requerido from "../../Tarjetas/Tarjeta_Cuentas_Documento_Requerido";

const Formulario_Cuentas_Documentos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'documentos',
        Formulario: Formulario_Cuentas_Documentos_Requeridos,
        Tarjeta: Tarjeta_Cuentas_Documento_Requerido
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Cuentas_Documentos